let data;
export const EnviornmentType = {
    DEV: "development",
    PROD: "production",
};
export const limit = 12;
export const env = EnviornmentType.DEV;
data = {
    API_ENDPOINT: process.env.REACT_APP_API_URL,
    API_VERSION: "",
    DOMAIN_LENGTH:5,
};
export const AppConfig = data;
